export const LmsRoutes = [
    {
        "url": '/elearning',
        "name": "elearning-northpass",
        "loginRequired": true,
        "type": "frontend",
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Northpass"
            }
        ],
        "abstract": true,
        "route_styles": {
            styles: ["lms"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/lms/lms.downgrade.module");
                }
            },
        ]
    },
    {
        "url": '/manager-learners',
        "name": "elearning-northpass.elearning-northpass-manager-dashboard-learners",
        "reloadOnSearch": false,
        "loginRequired": true,
        "type": "frontend",
        "views": {
            "body": {
                "component": "lmsManagerDashboardLearnersGridContainer"
            }
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Northpass: Learners | Harri"
            }
        ],
        "route_styles": {
            styles: ["lms"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/lms/lms.downgrade.module");
                }
            },
        ]
    },
    {
        "url": '/manager-learner?{learner_id:[0-9]+}',
        "name": "elearning-northpass.elearning-northpass-manager-dashboard-view-learners",
        "reloadOnSearch": false,
        "loginRequired": true,
        "type": "frontend",
        "views": {
            "body": {
                "component": "lmsManagerLearnerViewComponent"
            }
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Northpass: Learner | Harri"
            }
        ],
        "route_styles": {
            styles: ["lms"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/lms/lms.downgrade.module");
                }
            },
        ]
    },
];
//# sourceMappingURL=lms.routes.js.map